export const TITLE_BAR_HEIGHT = '58px';
export const CONTENT_TOP_PADDING = '24px';
